import PropTypes from 'prop-types'
import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import EditableFieldDialog from './editableFieldDialog'
import { formatDateString } from './formatters/dateFormatter'
import SalesForceFieldLink from './salesForceFieldLink'

@autobind
export default class RoomDetailsDialog extends Component {
  static propTypes = {
    show: PropTypes.bool,
    edits: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    room: PropTypes.object
  }

  render() {
    let { room } = this.props
    let fields = [
      { label: 'Room Name', value: room.name },
      {
        label: 'Is clean',
        value: room.isClean,
        type: 'checkbox',
        fieldName: 'isClean'
      },
      {
        label: 'Blackout From',
        value: room.blackoutFrom,
        valueRenderer: formatDateString
      },
      {
        label: 'Blackout To',
        value: room.blackoutTo,
        valueRenderer: formatDateString
      }
    ]
    return (
      <EditableFieldDialog
        {...this.props}
        title={<SalesForceFieldLink text='Room Details' id={room.id} />}
        fields={fields}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/roomDetailsDialog.js